import { render, staticRenderFns } from "./page_add_diy.vue?vue&type=template&id=fcf96ce4&scoped=true"
import script from "./page_add_diy.vue?vue&type=script&lang=js"
export * from "./page_add_diy.vue?vue&type=script&lang=js"
import style0 from "./page_add_diy.vue?vue&type=style&index=0&id=fcf96ce4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf96ce4",
  null
  
)

export default component.exports